import { render, staticRenderFns } from "./ordersusulanwholesalelist.vue?vue&type=template&id=2d7322e2"
import script from "./ordersusulanwholesalelist.vue?vue&type=script&lang=js"
export * from "./ordersusulanwholesalelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports